export enum StaticPermissionsEnum {
  View_customers_list = 1,
  View_customer_dashboard = 2,
  View_customer_profile = 3,
  Add_customer = 4,
  Edit_customer = 5,
  Activate_or_Deactivate_customer = 6,
  View_contracts_list = 7,
  Add_contract = 8,
  Cancel_contract = 9,
  Approve_or_Reject_contract = 10,
  Edit_contract = 11,
  Renew_contract = 12,
  On_Hold_contract = 13,
  View_contract_progress = 14,
  View_invoices = 15,
  //  Approve_or_Reject_contract=16,
  Generate_manual_invoice = 16,
  Add_payment_on_invoice = 17,
  Update_contract_settings = 18,
  View_orders_list = 19,
  Add_order = 20,
  View_order_details = 21,
  View_materials_list = 22,
  Add_material = 23,
  Edit_material = 24,
  Block_or_unblock_material = 25,
  Import_or_Export_material = 26,
  Issue_materials = 27,
  Update_price_list = 28,
  View_material_Free_requests = 29,
  Approve_or_Reject_Material_Free_request = 30,
  Update_materials_settings = 31,
  View_material_report = 32,
  Update_material_approval_cycle = 33,
  View_Payment_On_Invoice = 34,
  Cancel_Payment_On_Invoice = 35,
  Cancel_Invoice = 36,
  Edit_Invoice = 37,
  View_Nearly_Collected_Invoices = 38,
  Edit_Order = 39,
  View_Order_Progress = 40,
  View_Nearly_Expired_Contracts = 42,
  View_Contract_Details = 44,
  Export_Contracts = 45,
  Contracts_Report = 46,
  View_Material_Issue_Requests = 47,
  Approve_Reject_Material_Issue_Request = 48,
  View_Material_Issue_Request_Details = 49,
  View_Material_Free_Request_Details = 50,
  //View_Dashboard = 51,
  Approve_Reject_Invoice_Discount_Request = 54,
  View_Invoice_Discount_Requests = 55,
  View_Invoice_Discount_Request_Details = 60,

  // View_Timesheet = 70,
  //View_Orders_Report = 71,

  View_Teams_Report = 56,
  View_Customers_Report = 57,
  View_Stock_To_Service_Request = 61,
  Approve_or_Reject_Stock_To_Service_Request = 62,
  Extend_contract = 63,
  Statement_Of_Customer_Report = 64,
  Paid_Or_Unpaid_Invoices_Report = 65,
  view_order_material_report = 66,
  View_Stock_To_Service_Request_Details = 67,
  View_Material_Return_Requests = 68,
  View_NewDashboard = 69,
  Recieve_Call = 70,
  View_services_list = 71,
  Add_service = 72,
  Edit_service = 73,
  Block_or_unblock_service = 74,
  Import_or_Export_service = 75,
  
  Add_Lead = 200,
  Edit_Lead = 201,
  Convert_lead_to_Opportunity = 202,
  Convert_lead_to_MC = 203,
  Add_Opportunity = 204,
  Edit_Opportunity = 205,
  Opportunity_Listing = 206,
  Convert_Opportunity_To_McPotential = 207,
  Add_MCPotential = 208,
  Edit_MCPotential = 209,
  MCPotential_Listing = 210,
  Quotation_PriceList_Listing = 211,
  Edit_Quotation_PriceList = 212,
  Generate_Quotation = 213,
  View_Quotations_List = 214,
  View_Pending_Quotations_List = 215,
  View_Quotations_Expire_WithIn_Month_List = 216,
  View_Quotation_Detailes = 217,
  Edit_Quotation = 218,
  Lead_Listing = 219,
  Add_Quotation_PriceList = 220,
  Cancel_Quotation = 221,
  Convert_Quotation_To_Contract = 222,
  View_McPotential_Detailes = 224,
  Approve_or_Reject_Quotation = 223,

  View_return_material_request_details = 300,
  Approve_Reject_returned_material_request = 301,
  Edit_tasks = 400,
  View_Invoice_Detailes_Report = 401,
  View_Pending_contracts_list = 82,
  View_Customer_Delete_Requests = 402,
  Approve_or_Reject_Delete_Requests = 403,
  View_Tracking_Link=404,
  Print_Contract=405,
  Print_ContractRevenueAllocation=406,
  View_Guest_Orders_List = 407,
  View_Profit_Report = 410,
  View_Inventory_Transactions=411,
  Export_Inventory_Transactions=412,

  View_Exported_Files = 500,
    Grant_Invoice_Discount = 421,
  Edit_Invoice_Discription = 440,
  Block_or_unblock_customer = 408,
  ViewCustomerRateReport=550,

  // New CostEstimation configuration (config id 1500). No approval-cycle engine exists here -
  // each approval level is its own flat permission (First/Second/Third_Estimation_Approve) rather
  // than a generic Approve_Estimation, so an approver at one level can't act at any other level.
  // View/First/Second/Third/Cancel are the "Estimation Permissions" set (US-04, plus Third from
  // ADO #26045), and are validated on the backend too (EstimationManager.CurrentUserHasPermission),
  // not only via *permission here.
  View_Estimation = 1500,
  // Covers adding a material line to an estimation (admin panel "Add Material"), distinct from
  // approving it - a first/second approver does not get this permission.
  Add_Estimation = 1501,
  Cancel_Estimation = 1504,
  First_Estimation_Approve = 1505,
  Second_Estimation_Approve = 1506,
  // Final internal approval - also the permission that gates Send to Customer.
  Third_Estimation_Approve = 1507,
  // ADO #26128: add a discount on top of the current one while the estimation is Pending Customer
  // Approval (it then goes back to Pending to be Sent to Customer). Checked on the backend too.
  Additional_Discount = 1508,
  // Unpaid manual-invoice line edit from the invoice popup. Checked on the server as well
  // (ManualInvoiceManager.EditManualInvoicePermissionId). Distinct from Edit_Invoice (37),
  // which edits the manual invoice number and external reference on the list.
  Edit_Manual_Invoice = 1509
}
